module.exports = __webpack_public_path__ + "static/media/group-tool-white.1556cd2a.svg";